import { Tracking } from '../../types/LinkType';

// shared state across hooks
const globalTracking: { current: Tracking } = { current: { status: 'missing' } };

export function useGlobalTracking() {
  return [
    globalTracking,
    (tracking: Tracking) => {
      globalTracking.current = tracking;
    },
  ] as const;
}
